import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
// Handle messages coming from [Matrix] client if embedded as a [Widget] in some room.
// [Matrix]: https://matrix.org/
// [Widget]: https://docs.google.com/document/d/1uPF7XWY_dXTKVKV7jZQ2KmsI19wn9-kFRgQ1tFQP7wQ/edit
var MatrixWidget = /*#__PURE__*/function () {
  function MatrixWidget() {
    _classCallCheck(this, MatrixWidget);
    this.widgetId = null;
    window.addEventListener('message', this.onMessage.bind(this));
  }
  return _createClass(MatrixWidget, [{
    key: "onMessage",
    value: function onMessage(event) {
      this.widgetId = this.widgetId || event.data.widgetId;
      switch (event.data.api) {
        case 'fromWidget':
          break;
        case 'toWidget':
          switch (event.data.action) {
            case 'capabilities':
              this.sendResponse(event, {
                capabilities: ['m.always_on_screen']
              });
              break;
          }
          break;
        default:
          break;
      }
    }
  }, {
    key: "sendContentLoaded",
    value: function sendContentLoaded() {
      this.sendMessage({
        action: 'content_loaded'
      });
    }
  }, {
    key: "setAlwaysOnScreen",
    value: function setAlwaysOnScreen(value) {
      // Extension of main spec, see https://github.com/matrix-org/matrix-doc/issues/1354
      this.sendMessage({
        action: 'set_always_on_screen',
        value: value,
        // once for spec compliance
        data: {
          value: value
        } // and once for Riot
      });
    }
  }, {
    key: "sendMessage",
    value: function sendMessage(message) {
      if (!this.widgetId) return;
      message.api = message.api || 'fromWidget';
      message.widgetId = message.widgetId || this.widgetId;
      message.requestId = message.requestId || Math.random().toString(36);
      window.parent.postMessage(message, '*');
    }
  }, {
    key: "sendResponse",
    value: function sendResponse(event, response) {
      event.data.response = response;
      event.source.postMessage(event.data, event.origin);
    }
  }]);
}();
window.matrixWidget = new MatrixWidget();